import { Component, ChangeDetectorRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormArray, ValidatorFn, Validators,  } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

import { DialogHelper, ExceptionHelper } from './../../../../helper';

import * as $ from 'jquery';
import 'datatables.net';
import 'datatables.net-bs4';
import { saveAs } from 'file-saver';
import { EquipmentAssignFormService } from './equipment-assign-form.service';
import { EquipmentSummaryService } from '..';

@Component({
  selector: 'app-equipment-assign-form',
  templateUrl: './equipment-assign-form.component.html',
  styleUrls: ['./equipment-assign-form.component.css']
})
export class EquipmentAssignFormComponent implements OnInit {
  @ViewChild('dangerModal') dangerModal: any;

  eqDetailId: string;
  isDownloading = false;
  equipmentFormsForm: FormGroup;
  equipmentId: string;
  list: any = [];
  quantity= [];
  private assignedFormList: Array<{id, status, number}> = [];
  private redirect = true;
  private checkedFormList = [];

  constructor(
    private assignFormService: EquipmentAssignFormService,
    private chRef: ChangeDetectorRef,
    private dialog: DialogHelper,
    private exception: ExceptionHelper,
    private equipmentSummaryService: EquipmentSummaryService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private translateService: TranslateService,
    ) {
    this.translateService.setDefaultLang('en-us');
    this.route.params.subscribe(params => {
      this.equipmentId = params['equipmentId'];
    });

  }

  ngOnInit() {
    this.getForms();
    this.updateFormTable();
  }

  assignForms() {
    let checkedItems = this.list.filter((y, i) => this.equipmentFormsForm.get('formCheckboxArray').value[i] === true).map((x, i) => {
      return {
        id: x.id,
        number: this.equipmentFormsForm.get('numArray').value[this.list.findIndex(z => z.id === x.id)] || 0,
        status: 1
      }
    });
      
    this.assignFormService.assignForms(this.equipmentId, checkedItems).subscribe(res => {
      this.dialog.showModal('showSucModalBtn');
    }, err => {
      this.exception.showError(err, 'showDanModalBtn');
      this.redirect = false;
    });
  }

  checkboxValidator(): ValidatorFn {
    return (control: AbstractControl): {[key: string]: any} | null  => {
      const checkBoxArray = control.value as Array<boolean>;
      return checkBoxArray.every(x => x === false) ?
       {isChecked: false} : null ;
    };
  }

  downloadFormTemplate(formId) {
    this.isDownloading = true;
    this.assignFormService.getFormTemplate(formId).subscribe(data => {
      const blob = new Blob([data.file], { type: 'application/pdf' });
      saveAs(blob, data.fileName);
      this.isDownloading = false;
    }, error => {
      this.isDownloading = false;
      this.exception.showError(error, 'showDanModalBtn');
      this.redirect = false;
    });
  }

  getForms() {


    this.assignFormService.getForms(this.equipmentId).subscribe(data => {
      if (data.formListModel && data.formListModel.length > 0) {
        this.list = data.formListModel;
        this.checkedFormList = data.checkedListModel;
        this.equipmentFormsForm = this.fb.group({
          formCheckboxArray: new FormArray(
            Array.from(new Array(this.list.length), x => new FormControl(false)),
          ),
          numArray: new FormArray(
            Array.from(new Array(this.list.length), x => new FormControl(1, [Validators.min(0)])),
          ),
        });
        const formCheckboxList = this.equipmentFormsForm.get('formCheckboxArray').value;
        const numList = this.equipmentFormsForm.get('numArray').value;

        for (let i = 0 ; i < this.checkedFormList.length; i++) {
          const matchItemIndex = this.list.findIndex(x => x.id === this.checkedFormList[i].id);
          if (matchItemIndex === -1) {
            continue;
          }
          formCheckboxList[matchItemIndex] = true;
          numList[matchItemIndex] = this.checkedFormList[i].number
        }
        this.equipmentFormsForm.get('formCheckboxArray').setValue(formCheckboxList);
        this.equipmentFormsForm.get('numArray').setValue(numList);
        
        this.equipmentFormsForm.get('formCheckboxArray').valueChanges.subscribe((values: Array<boolean>) => {
          this.assignedFormList = [];
          values.filter((isChecked, index) => {
            this.assignedFormList.push({
              id: this.list[index].id,
              status: Number(isChecked === true),
              number: this.list.num
            });
            this.quantity[index] = this.list.num || 0;
          });
          
        });
        this.updateFormTable();
      } else {
        this.list = [];
      }
      this.quantity = Array.from({length: this.list.length}, (x, i) => 0);
    }, err => {
      this.exception.showError(err, 'showDanModalBtn');
      this.redirect = false;
    });
  }

  selectAll(event) {

    this.equipmentFormsForm.get('formCheckboxArray').setValue(
        new Array(this.list.length).fill(event.target.checked)
    );

  }
  updateFormTable() {
    this.chRef.detectChanges();
    if ($.fn.dataTable.isDataTable('#pmFormDataTable')) {
      $('#pmFormDataTable').DataTable().destroy();
    }

    $('#pmFormDataTable').DataTable({
      autoWidth: true,
      // scrollX: true
    });
  }
  closeSuccessModel() {
    this.router.navigate(['/home/equipment/detail/' + this.equipmentId]);
  }

  errorClose() {
    if (this.redirect) {
      this.router.navigate(['/home/equipment']);
    } else {
      this.dangerModal.hide();
    }

  }
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/equipment/equipment-assign-form/equipment-assign-form.component.ts